import { RootState } from '../../../../rootReducer';

export const audittrailReportSelector = (state: RootState) => state.eventsLogModuleReducer.AuditTrailReportReducer;
